import { EvidenceChip } from "./EvidenceChip";

export const METRIC = {
  "outcome.earnings_15m": "Median earnings, 15 months after graduating",
  "outcome.earnings_1y": "Median earnings, 1 year after completing",
  "outcome.earnings_3y": "Median earnings, 3 years after graduating",
  "outcome.earnings_4y": "Median earnings, 4 years after completing",
  "outcome.earnings_5y": "Median earnings, 5 years after graduating",
  "outcome.continuation": "Still on the course or completed after year 1",
  "outcome.in_work_or_study": "In work and/or study after 15 months",
  "outcome.professional_jobs": "In highly skilled work after 15 months",
};

// One aggregate outcome, always printed with whose data it is, how many people and which period.
export function OutcomeTile({ o, testId }) {
  return (
    <div data-testid={testId} className="rounded-xl border border-stone-200 bg-[#FDFBF7] p-4">
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs text-stone-600">{METRIC[o.field] || o.field}</p>
        <EvidenceChip claim={o} subtle testId={`${testId}-source`} />
      </div>
      <p className="mt-1 font-mono text-2xl text-stone-900" data-testid={`${testId}-value`}>{o.value}</p>
      {o.range && <p className="font-mono text-[11px] text-stone-500">range {o.range}</p>}
      <p className="mt-2 text-[11px] leading-snug text-stone-600" data-testid={`${testId}-population`}>
        <span className="font-medium text-stone-700">Who:</span> {o.population}
      </p>
      <p className="text-[11px] leading-snug text-stone-500">{[o.sample, o.period, o.source_name].filter(Boolean).join(" · ")}</p>
    </div>
  );
}
